<div *ngIf="notes" class="mt-2 flex-1">
  <div class="py-3 px-3 background flex-row layout-gap">
    <div class="flex-column flex-place-content-center">
      <mat-icon class="icon">chat</mat-icon>
    </div>

    <div class="flex-column">
      <span class="mat-body-2">Auditing Notes </span>
      <div class="text-wrap">{{ notes }}</div>
    </div>
  </div>
</div>
